import store from '@/store';



const goToOrderPage = {
  redirectToTableTopViewBill() {
    const { route } = store.state.session;

    let query = '?';

    if (route.merchantLocationId) {
      query += `&ml=${route.merchantLocationId}`;
    }

    if (route.tableNumber) {
      query += `&tb=${route.tableNumber}`;
    }

    window.location.replace(`/${route.merchantId}/order-at-table/view-bill${query}`);
  },

  redirect() {
    const { route } = store.state.session;

    let query = `?oi=${route.orderId}`;

    if (route.sublocationToken) {
      query += `&st=${route.sublocationToken}`;
    }

    if (route.merchantLocationId) {
      query += `&ml=${route.merchantLocationId}`;
    }

    if (route.ticketNumber) {
      query += `&tn=${route.ticketNumber}`;
    }

    if (route.tableNumber) {
      query += `&tb=${route.tableNumber}`;
    }

    window.location.replace(`/${route.merchantId}/pay-at-table/checkout${query}`);
  },

  shouldShowButton() {
    return !!store.state.session.route.orderId;
  }
};



export default goToOrderPage;
